// TODO WTF ? (neither interface or type)
export const ProDocumentTypes = new Map<string, string>([
  ['contract', 'Contrat'],
  ['mandate', 'Mandat de prélèvement'],
  ['insurance', 'Assurance'],
  ['other', 'Autre'],
  ['import', 'IMPORT'],
]);
